// src/components/XPDisplay.tsx
import React from 'react';
import { LevelIcon } from './LevelIcon';
// Use Convex-based XP hook for real-time updates
import { useConvexXP } from '../hooks/convex/useConvexXP';

interface XPDisplayProps {
  onClick: () => void;
  collapsedMode?: boolean;
}

export const XPDisplay: React.FC<XPDisplayProps> = ({ onClick, collapsedMode = false }) => {
  // Use Convex hook for real-time XP updates - no manual refresh needed
  const { progress, loading } = useConvexXP();

  if (loading && !progress) {
    return <div className="p-2">Loading...</div>;
  }

  // If no progress data or invalid structure, show placeholder
  if (!progress || !progress.xp) {
    return (
      <div
        className="flex items-center gap-2 cursor-pointer p-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
        onClick={onClick}
      >
        <LevelIcon level="explorer" />
        {!collapsedMode && (
          <span className="text-sm font-medium">
            0 XP
          </span>
        )}
      </div>
    );
  }

  const totalXP = progress.xp.total_xp;
  const currentLevel = progress.xp.current_level as unknown as import('../types/xp').UserLevel;

  return (
    <div
      className="flex items-center gap-2 cursor-pointer p-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
      onClick={onClick}
    >
      <LevelIcon level={currentLevel} />
      {!collapsedMode && (
        <span className="text-sm font-medium">
          {totalXP.toLocaleString()} XP
        </span>
      )}
    </div>
  );
};
